import React from 'react';
import { SVGProps } from '../../helpers/types';

const ChevronUp: React.FC<SVGProps> = () => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.99996 0.0493164L-6.10352e-05 6.04934L1.40994 7.45934L5.99996 2.87933L10.59 7.45934L12 6.04934L5.99996 0.0493164Z"
        fill="#8D8885"
      />
    </svg>
  );
};

export default ChevronUp;
